import { COLOR, histogram, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MACD',
  version: 2,
  label: 'MACD',
  pane: 'sub',
  category: 'momentum',
  series: 'price',
  order: 10,
  inputs: [period('fastperiod', 12, 'Fast length'), period('slowperiod', 26, 'Slow length'), period('signalperiod', 9, 'Signal length')],
  outputs: [line('macd', 'MACD', COLOR.blue), line('signal', 'Signal', COLOR.orange), histogram('hist', 'Histogram', COLOR.green, COLOR.red)],
  talib: {
    functions: ['MACD'],
    expr: 'MACD(close, fastperiod={fastperiod}, slowperiod={slowperiod}, signalperiod={signalperiod})',
    outputs: { macd: 'macd', signal: 'macdsignal', hist: 'macdhist' },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ fastperiod, slowperiod, signalperiod }) => Math.max(fastperiod, slowperiod) - 1 + (signalperiod - 1),
}
export default def
